/**
 * Menu store - Menu visibility and tutorial-from-menu state.
 * Replaces MenuContext state. Handlers (handleMenuPress, handleSignOut, etc.) live in useMenuContext hook.
 */

import { create } from 'zustand';

interface MenuStoreState {
  menuVisible: boolean;
  tutorialFromMenuVisible: boolean;
  layeredAvatarLabVisible: boolean;
  /** True only when the customizer was drilled into from the menu drawer, so closing it returns there. */
  reopenMenuOnCustomizerClose: boolean;
  setMenuVisible: (visible: boolean) => void;
  setTutorialFromMenuVisible: (visible: boolean) => void;
  openLayeredAvatarLab: (options?: { reopenMenuOnClose?: boolean }) => void;
  closeLayeredAvatarLab: () => void;
  clearReopenMenuOnCustomizerClose: () => void;
}

export const useMenuStore = create<MenuStoreState>((set) => ({
  menuVisible: false,
  tutorialFromMenuVisible: false,
  layeredAvatarLabVisible: false,
  reopenMenuOnCustomizerClose: false,
  setMenuVisible: (visible) => set({ menuVisible: visible }),
  setTutorialFromMenuVisible: (visible) => set({ tutorialFromMenuVisible: visible }),
  // Single action so visibility and the return-target can never be set out of order.
  openLayeredAvatarLab: (options) =>
    set({
      layeredAvatarLabVisible: true,
      reopenMenuOnCustomizerClose: options?.reopenMenuOnClose ?? false,
    }),
  closeLayeredAvatarLab: () => set({ layeredAvatarLabVisible: false }),
  clearReopenMenuOnCustomizerClose: () => set({ reopenMenuOnCustomizerClose: false }),
}));
